import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/maxcdn': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M461.1 442.7h-97.4l51.9-242.7c2.3-10.2 0.9-19.5-4.4-25.7-5-6.1-13.7-9.6-24.2-9.6h-49.3l-59.5 278h-97.4l59.5-278h-83.4l-59.5 278h-97.4l59.5-278-44.6-95.4h372.1c39.4 0 75.3 16.3 98.3 44.9 23.3 28.6 31.8 67.4 23.6 105.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/maxcdn.js
// module id = 925
// module chunks = 0